import actions from 'actions';

/**
 * ReducerName's reducer.
 * @param {String} state  Existing ReducerName's state
 * @param {Object} action Action dispatched
 * @return {Object} New state
 */
export default (state = { events: {}, needLogin: true }, action) => {
    switch (action.type) {
        case actions.RECEIVED_CHECK_AUTH:
            return { ...state, needLogin: false, ...action.auth };
        default:
            return state;
    }
};
